// extracted by mini-css-extract-plugin
export default {"remove-item":"ContextMenuItems_remove-item__9vIJ5"};